import React, { useEffect, useState, useRef } from "react";
import { AnimatePresence } from "framer-motion";
import { useLocation, useRoutes } from "react-router-dom";
import { routesConfig } from "./config/routes";

import './App.scss';
import PageLayout from './components/PageLayout';
import { pageTransitionDelay, pageTransitionDuration } from "./config/constants";
import { HeaderProvider } from "./config/headerContext";

function App() {
    const containerRef = useRef(null);
    const [overlayVisible, setShowOverlay] = useState(false);
    const element = useRoutes(routesConfig);
    const location = useLocation();
    const htmlRoot = document.getElementsByTagName("html")[0];

    const currentRoute = routesConfig.find(route =>
        route.path === location.pathname ||
        (route.path.includes(':') && new RegExp(`^${route.path.replace(/:\w+/g, '\\w+')}$`).test(location.pathname))
    );

    const currentPageClass = location.pathname === "/"
        ? "home"
        : currentRoute
            ? currentRoute.class
            : "error";

    useEffect(() => {
        if (!htmlRoot.getAttribute("overlay")) {
            htmlRoot.setAttribute("overlay", "hidden");
        } else {
            setShowOverlay(true);
            htmlRoot.setAttribute("overlay", "visible");

            const timer = setTimeout(() => {
                setShowOverlay(false);
                htmlRoot.setAttribute("overlay", "hidden");
            }, (pageTransitionDuration + pageTransitionDelay) * 1000);
            return () => clearTimeout(timer);
        }
    }, [htmlRoot, location, currentPageClass]);

    return (
        <HeaderProvider>
            <AnimatePresence mode="wait">
                <PageLayout key={location.pathname}>
                    <div className="content" ref={containerRef} data-scroll-container>
                        {React.cloneElement(element, {
                            key: location.pathname,
                            page: currentPageClass,
                            overlayVisible,
                            setShowOverlay
                        })}
                    </div>
                </PageLayout>
            </AnimatePresence>
        </HeaderProvider>
    );
}

export default App;
